let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jp5mX")).then(() => parcelRequire('5SuH4'));